import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import useFetchSearchGeneralAndNavToResult from './useFetchSearchGeneralAndNavToResult';
import useFetchNlpSearchAndApplyFilters from './useFetchNlpSearchAndApplyFilters';
import { useEffect } from 'react';

// This hook is really only meant to be used in m.tsx
// It will remove the q or nlp query params from the url, and then perform the search, and then do some navigation
export default function useRemoveAndPerformSearchFromSpecialQueryParams(
  initialGeneralQuery,
  initialNlpQuery,
) {
  const [fetchSearchGeneralAndNavToResult] =
    useFetchSearchGeneralAndNavToResult();
  const [fetchNlpSearchAndApplyFilters] = useFetchNlpSearchAndApplyFilters();

  const router = useRouter();
  const params = useSearchParams();
  const pathname = usePathname();

  function removeQueryParamsFromUrl(queryKey: string): void {
    const oldParams = new URLSearchParams(params.toString());
    oldParams.delete(queryKey);
    const newParams = new URLSearchParams(oldParams.toString());
    router.replace(`${pathname}?${newParams.toString()}`);
  }

  useEffect(() => {
    if (params.get('q')) removeQueryParamsFromUrl('q');
    if (params.get('nlp')) removeQueryParamsFromUrl('nlp');
  }, [params]);

  useEffect(() => {
    if (initialGeneralQuery) {
      fetchSearchGeneralAndNavToResult(initialGeneralQuery);
    } else if (initialNlpQuery) {
      fetchNlpSearchAndApplyFilters(initialNlpQuery);
    }
  }, []);
}
